<template>
	<div class="pruritus-page">
		<time-num></time-num>
		<div class="pruritus-page-main">
			<div class="top-content">
				<span>请查看该病例的</span>
				<span>瘙痒评分</span>
			</div>
			<div class="content-img">
				<img @click="handleImgAmplify" :src="initArr.scoreSheet" alt />
				<div class="text">点击图片放大查看</div>
			</div>
		</div>
		<div class="footer">
			<!-- <div class="nextquestionactive" @click="$router.replace('/treat/Catalog')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div> -->
			<div @click="handleNextBtn" class="text">下一步</div>
		</div>
		<van-dialog v-model="imgAmplify" :showConfirmButton="false" :closeOnClickOverlay="true" class="dialogImg">
			<div class="imgAmplify">
				<img :src="initArr.scoreSheet" alt />
			</div>
		</van-dialog>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import TimeNum from "../mixins/timeNum";
	import MiXin from "../mixins/index";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		components: {
			MiXin,
			TimeNum,
		},
		name: "Home2026",
		data() {
			return {
				isShow: true,
				clientHeightFlag: true,
				imgAmplify: false,
				initArr: [],
			};
		},
		computed: {
			...mapState("visualExamination", ["treatmentList", //步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				"treatmentEcho"
			]),
			...mapState("microscope", ["examDetailId"]),
		},
		created() {
			this.initArr = this.treatmentList;
		},
		mounted() {
			if (document.documentElement.clientHeight >= 1038) {
				this.clientHeightFlag = false;
			} else {
				this.clientHeightFlag = true;
			}
		},
		methods: {
			//下一步
			handleNextBtn() {
				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(parmes),
					paperId: this.treatmentList.id,
					questionId: '-208',
					answers: JSON.stringify({
						detail: this.detail,
						detailsz2: this.detailsz2,
						detail3: this.detail3,
						detailstepPre3: this.detailstepPre3,
						detail4: this.detail4,
						detail5: this.detail5,
						treatmentEcho: this.treatmentEcho
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.$router.replace({
						path: "/treat/medicalrecord",
						query: {
							num: 1.1
						},
					});
				});
			},
			//放大图片
			handleImgAmplify() {
				this.imgAmplify = true;
			},
		},
	};
</script>

<style lang="less" scoped>
	.pruritus-page {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;

		.pruritus-page-main {
			padding: 10px 51px 0px 51px;
			box-sizing: border-box;
			overflow: auto;

			.top-content {
				height: 196px;
				background: rgba(255, 255, 255, 0.3);
				box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
				border: 2px solid #ffffff;
				border-radius: 60px;
				font-size: 45px;
				font-weight: bold;
				color: #ab3b91;
				display: flex;
				align-items: center;
				flex-direction: column;
				padding-top: 50px;
			}

			.content-img {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin-top: 48px;
				margin-bottom: 185px;

				img {
					width: 596px;
					margin-bottom: 37px;
				}

				.text {
					font-size: 35px;
					font-weight: bold;
					color: #ffffff;
				}
			}
		}

		.footer {
			position: fixed;
			bottom: 0;
			width: 100%;
			height: 183px;
			border-radius: 60px 60px 0px 0px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-around;
			margin-top: 51px;

			.text {
				width: 274px;
				height: 85px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				border-radius: 42px;
				text-align: center;
				line-height: 85px;
				font-size: 35px;
				font-weight: 500;
				color: #ffffff;
			}
		}

		.dialogImg {
			border-radius: 0;
			width: 92%;

			.imgAmplify {
				width: 100%;

				img {
					width: 100%;
				}
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 214px;
		height: 88px;
		border-radius: 100px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 214px;
		height: 88px;
		border-radius: 100px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>